import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';
import 'react-table/react-table.css';
import './Quick-Answer.scss';
import { DateRangePicker } from 'react-dates';
import moment from 'moment';


const SearchResults = () => {

    const [loading, setLoading] = useState(true)

    const [resultHub, setResultHub] = useState({})
    const [resultBSM, setResultBSM] = useState()
    const [resultExtranet, setResultExtranet] = useState()
    const [resultTotal, setResultTotal] = useState()
    const [qtdTermos, setQtdTermos] = useState(5)
    const [filters, setFilters] = useState({
        order: {
            startDate: moment().subtract(30, 'days'),
            endDate: moment(),
            gte: null,
            lte: null,
            focusedInput: null,
        },
    });

    const chamaPalavra = () => {
        setLoading(true)
        const config = new Configurations();
        axios.get(config.apiBasePath + `/kpi/pesquisa/totais-palavras?dtInicio=${filters.order.startDate.format('YYYY-MM-DD')}&dtFim=${filters.order.endDate.format('YYYY-MM-DD')}&page=1&pageSize=${qtdTermos}`)
            .then(response => {
                setResultHub(response.data.HUB)
                setResultBSM(response.data.BSM)
                setResultExtranet(response.data.Extranet)
                setResultTotal(response.data.Geral)
            })
            .catch(error => {
                console.log("ERROR: ", error)
            })
            .finally(() => {
                setLoading(false)

            });
    }

    const renderTabela = (titulo, dados) => {
        return (
            <div className='col-12 col-lg-6 pb-2' key={titulo}>
                <h3 className='text-center'>{titulo}</h3>
                <table className="table bg-white border p-2">
                    <thead>
                        <tr>
                            <th className='text-center'>Termo</th>
                            <th className='text-center'>Quantidade</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dados.length > 0 ? (
                            dados.map((item, index) => (
                                <tr key={index}>
                                    <td className='text-center'>{item.termoBuscado}</td>
                                    <td className='text-center'>{item.quantidade}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="2">Nenhum dado disponível</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        );
    };

    const handleDatesChange = useCallback((attr) => ({ startDate, endDate }) => {
        setFilters(prevFilters => {
            const newDates = { ...prevFilters[attr], startDate, endDate };
            if (startDate) {
                newDates.gte = startDate.format("YYYY[-]MM[-]DD");
            } else {
                delete newDates.gte;
            }

            if (endDate) {
                newDates.lte = endDate.format("YYYY[-]MM[-]DD");
            } else {
                delete newDates.lte;
            }

            return { ...prevFilters, [attr]: newDates };
        });

    }, []);

    const handleFocusChange = useCallback((focusedInput) => {
        setFilters(prev => ({
            ...prev,
            order: { ...prev.order, focusedInput },
        }));
    }, []);

    const podeBuscar = () => {
        const dataInicialValida = filters.order.startDate;
        const dataFinalValida = filters.order.endDate;

        if (!dataInicialValida) {
            return true
        }
        if (!dataFinalValida) {
            return true
        }
    }

    const qtdItens = [
        5,
        10,
        15,
        20,
        25,
        30
    ]

    const handleQtdChange = (e) => {
        setQtdTermos(e.target.value)
    }

    useEffect(() => {
        chamaPalavra()
    }, [])

    return (
        <>
            <div className="row ">
                <div className='col-12'>
                    <div className="row no-gutters py-3 d-flex justify-content-between">
                        <div className=''>
                            <h2 className="d-none d-lg-block">Termos mais pesquisados</h2>
                        </div>
                        <div className="">
                            <button onClick={() => window.history.go(-1)} className="btn btn-outline-secondary">Voltar</button>
                        </div>
                    </div>
                </div>
            </div>

            <div className='card'>
                <div className='card-body'>
                    <div className='row my-4 d-flex justify-content-center align-items-center'>
                        <div className='px-2'>
                            <select id="qtdTermos" name="qtdTermos" className="form-control" value={qtdTermos} onChange={handleQtdChange}>
                                {qtdItens.map((item, index) => {
                                    return (
                                        <option key={index} value={item}>{item} Termos</option>
                                    )
                                })}
                            </select>
                        </div>
                        <div className='px-2'>
                            <DateRangePicker
                                showClearDates
                                enableOutsideDays
                                isOutsideRange={() => false}
                                startDate={filters.order.startDate}
                                startDateId="dpOrderStartDate"
                                endDate={filters.order.endDate}
                                endDateId="dpOrderEndDate"
                                onDatesChange={handleDatesChange("order")}
                                focusedInput={filters.order.focusedInput}
                                onFocusChange={handleFocusChange}
                                displayFormat="DD/MM/YYYY"
                                startDatePlaceholderText="Data inicial"
                                endDatePlaceholderText="Data final"
                            />
                        </div>
                        <div className='px-2 button-buscar-resultado'>
                            <button onClick={() => chamaPalavra()} disabled={podeBuscar()} className="btn btn-outline-success">
                                Buscar
                            </button>
                        </div>
                    </div>

                    {loading ?
                        <div className='row p-5'>
                            <div className='col-12 text-center'>
                                <div className="spinner-border text-primary" role="status" />
                            </div>
                        </div>
                        :
                        <div className='row'>
                            {renderTabela("Portal", resultHub)}
                            {renderTabela("BS+", resultBSM)}
                            {renderTabela("Extranet", resultExtranet)}
                            {renderTabela("Geral", resultTotal)}
                        </div >
                    }
                </div>
            </div>
        </>
    )
}

export default SearchResults;
